import { format } from "date-fns";
import { instance } from "../api-instance";

export const JuicyScoreApi = {
  saveSession(
    {
      applicationId,
      sessionId,
      contactId,
    }: {
      applicationId: string;
      sessionId: string;
      contactId: string;
    },
    signal: AbortSignal
  ): Promise<unknown> {
    const today = new Date();
    const clientTime = format(today, "dd.MM.yyyy HH:mm:ss");
    const clientTimeZone = (-today.getTimezoneOffset() / 60).toString();

    return instance
      .post(
        "/Scoring/juicyScore/SaveSession",
        {
          applicationId,
          sessionId,
          clientTime,
          clientTimeZone,
          contactId,
        },
        { signal }
      )
      .then((res) => res.data);
  },
};
